function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#b58e3b"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M60 49.114a5 5 0 01-2.5 4.329l-25 14.444a5 5 0 01-5 0l-25-14.444A5 5 0 010 49.114v-28.9a5 5 0 012.5-4.329l25-14.44a5 5 0 015 0l25 14.445a5 5 0 012.5 4.329z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M55 20.219L30 5.775 5 20.219v28.895L30 63.56l25-14.445V20.22m5 0v28.895a5 5 0 01-2.499 4.33l-25 14.444a5 5 0 01-5.002 0l-25-14.444A5 5 0 010 49.114V20.22a5 5 0 012.499-4.33l25-14.444a5 5 0 015.002 0l25 14.445A5 5 0 0160 20.219z",
  fill: "rgba(255,255,255,.21)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.577 47a1.579 1.579 0 01-1.188-.529 1.618 1.618 0 01-.373-1.282l2.464-16.761a3.055 3.055 0 012.943-2.576h2.939v-2.176-.037a6.64 6.64 0 1113.279 0v2.213h3.02a3.015 3.015 0 012.894 2.6l2.407 16.719a1.515 1.515 0 01-.27 1.274 1.488 1.488 0 01-1.185.555zm2.361-18.355l-2.462 16.748a.135.135 0 00.023.1c.005.006.023.027.077.027h26.93c.017.015.022 0 .012-.042s-.01-.047-.014-.07l-2.412-16.761a1.525 1.525 0 00-1.432-1.319h-3.019v3.609a1.722 1.722 0 11-1.475 0v-3.609H24.837v3.609a1.722 1.722 0 11-1.475 0v-3.609h-2.939a1.593 1.593 0 00-1.485 1.317zm16.718 3.847a.248.248 0 00.248.245.246.246 0 000-.492.248.248 0 00-.248.248zm-11.8 0a.246.246 0 10.248-.248.248.248 0 00-.252.249zm11.313-6.64v-2.213a5.167 5.167 0 00-10.333-.032v2.245z",
  fill: "#fff"
});

var SvgAchievementWardrobe = function SvgAchievementWardrobe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 60 70",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAchievementWardrobe, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/AchievementWardrobe.f360f1b1.svg";
export { ForwardRef as ReactComponent };